var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "avue-top flex-start" }, [
    _c(
      "div",
      { staticClass: "top-bar__right" },
      [
        _c("div", { staticClass: "margin-right-40" }, [
          _c(
            "div",
            {
              staticClass: "flex-center flex-col pointer",
              on: { click: _vm.gohelpPage },
            },
            [
              _c("img", {
                staticStyle: { width: "22px", height: "22px" },
                attrs: { src: require("@/static/icon_top_help.png"), alt: "" },
              }),
              _c("span", { staticClass: "color-666 font-12" }, [
                _vm._v("帮助中心"),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "margin-right-40" }, [_c("top-notice")], 1),
        _c(
          "div",
          { staticClass: "flex-center margin-right-40" },
          [_c("top-lock")],
          1
        ),
        _c("div", { staticClass: "flex-center margin-right-40" }, [
          _c(
            "div",
            {
              staticClass: "flex-center flex-col pointer",
              on: { click: _vm.handleScreen },
            },
            [
              _vm.isFullScren
                ? _c("img", {
                    staticStyle: { width: "22px", height: "22px" },
                    attrs: {
                      src: require("@/static/icon_top_nofull.png"),
                      alt: "",
                    },
                  })
                : _c("img", {
                    staticStyle: { width: "22px", height: "22px" },
                    attrs: {
                      src: require("@/static/icon_top_full.png"),
                      alt: "",
                    },
                  }),
              _c("span", { staticClass: "color-666 font-12" }, [
                _vm._v("全屏"),
              ]),
            ]
          ),
        ]),
        _vm.userInfo.avatar
          ? _c("img", {
              staticClass: "top-bar__img",
              attrs: { src: _vm.userInfo.avatar },
            })
          : _c("img", {
              staticClass: "top-bar__img",
              attrs: { src: require("@/static/login/avatar-small.png") },
            }),
        _c(
          "el-dropdown",
          [
            _c("span", { staticClass: "el-dropdown-link color-333" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.userInfo.username) + "\n        "
              ),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
            ]),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c(
                  "el-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _vm._v(_vm._s(_vm.$t("navbar.dashboard"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/user/profile" } }, [
                      _vm._v(_vm._s(_vm.$t("navbar.userinfo"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { divided: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.logout.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("navbar.logOut")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }